import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// components/gitbiz/solutions/ca-firm/index.jsx (rendered by the deleted
// app/(homes)/(hrms)/hrms-software/solutions/ca-firm/page.jsx) onto the content
// engine (template "solution"). Copy, images, links match the original.
// SEO comes from GeneralPageSEOMetadata.json via <SEO> (its "ca-firm" entry).

export const caFirm: ContentPage = {
  slug: "solutions/ca-firm",
  template: "solution",
  seo: {
    title: "Software Solutions for CA Firms | GetBiz Solutions",
    description: "GetBiz Solutions offers software solutions for CA firms, helping with client management, compliance tracking, and workflow automation.",
    keywords: [
      "CA firm software",
      "client management",
      "compliance tracking",
      "workflow automation",
      "CA firm solutions",
      "accounting software",
      "practice management tools",
      "financial management",
    ],
    ogImage: "/assets/data/seoimages/ca-firm.webp",
  },
  solution: {
    hero: {
      title: "Simplify compliance and reporting tasks.",
      description: "Streamline your accounting processes for increased efficiency and accuracy.",
      image: "/assets/images/img/ca_firm_solutions.webp",
      imageAlt: "ca_firm_solutions",
      bgImage: "/assets/images/full-width-images/section-bg-10.jpg",
      ctaPrimary: { label: "Start 15 Days Trial", href: "/pricing/" },
      ctaSecondary: { label: "Book A Demo", href: "/book-demo/" },
    },
    servicesTitle: "Boost Efficiency with HRMS for CA Firms",
    services: [
      { title: "Employee Attendance Tracking", description: "Automate attendance tracking to monitor work hours and leave requests, ensuring compliance with firm policies." },
      { title: "Billing and Invoicing Automation", description: "Simplify client billing and automate invoicing for services, ensuring timely payments and error-free accounting." },
      { title: "Task Assignment and Monitoring", description: "Assign tasks to teams and monitor their progress, ensuring deadlines are met and work is evenly distributed." },
      { title: "Document Management", description: "Store and manage important client documents and financial records securely, reducing paperwork." },
      { title: "Client Communication", description: "Automate communication with clients, including updates on tax filings, audits, and reports to improve service delivery." },
      { title: "Compliance and Reporting", description: "Keep track of legal compliance, financial deadlines, and employee certifications using automated reminders and reports." },
    ],
    ctaStrip: {
      description: "Book a personalized demo to see how our solutions can transform your business and boost your efficiency.",
      button: { label: "Book A Demo", href: "/book-demo/" },
    },
    faqDescription: "Find out how GetBiz Solutions software solutions support CA firms. Our FAQs cover tools for managing client records, automating workflows, and tracking important deadlines. Discover how you can enhance your firm’s efficiency, ensure compliance, and offer better services to your clients with tailored solutions that save time and reduce manual errors.",
    metaKey: "ca-firm",
  },
  sections: [],
};
